@use '../../../common/styles/variables' as *;
@use '../../../common/mixins/inputs' as *;

:host {
  display: block;
  height: auto;
  @include default-css-variables;
  width: 100%;
}

label {
  @include input-label;
  flex-direction: column;
  gap: 4px;
  font-family: var(--nylas-font-family);
  font-size: 16px;
  color: var(--nylas-base-800);

  p {
    margin: 0;
  }

  .error {
    color: var(--nylas-error);
    border-color: var(--nylas-error);
  }
}

.input_wrapper {
  display: flex;
  align-items: center;
  gap: 1rem;
}

input[type='date'] {
  @include textfield;
  width: 100%;
  width: -moz-available;
  width: -webkit-fill-available;
  font-family: var(--nylas-font-family);
  padding: 0 8px;
  cursor: pointer;
  &::-webkit-calendar-picker-indicator {
    filter: invert(37%) sepia(51%) saturate(6324%) hue-rotate(215deg) brightness(94%) contrast(95%);
    cursor: pointer;
  }
}

input:read-only {
  background-color: var(--nylas-base-100);
  cursor: not-allowed;
}
